/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageordercountone4Inputs */

const en_ticketpageordercountone4 = /** @type {(inputs: Ticketpageordercountone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 order in total`)
};

const de_ticketpageordercountone4 = /** @type {(inputs: Ticketpageordercountone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Bestellung insgesamt`)
};

/**
* | output |
* | --- |
* | "1 order in total" |
*
* @param {Ticketpageordercountone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageordercountone4 = /** @type {((inputs?: Ticketpageordercountone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageordercountone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageordercountone4(inputs)
	return de_ticketpageordercountone4(inputs)
});
export { ticketpageordercountone4 as "ticketPageOrderCountOne" }